module.exports = __webpack_public_path__ + "img/a8_04.36459761.jpg";